'use client';

import { cn } from '@core/utils';
import { useRef } from 'react';

import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { usePublishElementHeight } from '@/hooks/usePublishElementHeight';

import { useGiftOption } from '../_context/GiftOptionContext';
import { GiftDonateButton } from './GiftDonateButton';

interface MobileGiftDonateFooterProps {
  productNumber: string;
  productInfo: GiftProductDetail;
}

export const MobileGiftDonateFooter = ({
  productNumber,
  productInfo,
}: MobileGiftDonateFooterProps) => {
  const { getSelectedOptions, quantity } = useGiftOption();
  const footerRef = useRef<HTMLDivElement>(null);

  usePublishElementHeight(footerRef, '--bottom-nav-portal-height');

  const optionGroups = productInfo.optionGroupInfoList ?? [];
  const hasOptions = optionGroups.length > 0;
  const requiredOptionGroupIds = optionGroups
    .filter((g) => g.requiredYN)
    .map((g) => g.optionGroupId);

  const scrollToOptionSection = () => {
    document
      .querySelector<HTMLElement>('[data-gift-option-section]')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  //* sticky는 iOS WebKit이 뒤로가기 스크롤 복원 직후 한 프레임 위치를 못 잡아 버튼이 사라진다.
  return (
    <div
      ref={footerRef}
      className={cn(
        'fixed inset-x-0 bottom-0 z-10 hidden w-full bg-Gray-white px-20 py-12',
        'mobile-tablet:flex mobile-tablet:items-center mobile-tablet:gap-8',
      )}
    >
      <GiftDonateButton
        className="flex-1"
        productNumber={productNumber}
        productInfo={productInfo}
        hasOptions={hasOptions}
        selectedOptions={getSelectedOptions(optionGroups)}
        requiredOptionGroupIds={requiredOptionGroupIds}
        onOptionNotSelected={scrollToOptionSection}
        quantity={quantity}
      />
    </div>
  );
};
